{"sm":640,"md":768,"lg":1080,"xl":1280,"2xl":1536,"xs":360,"3xl":1920}